import AllowDeleteProductWithOpenInvoicePage from "@faire/prototype-playground/workspace/hbul/allow-delete-product-with-open-invoice";
import DormantProductsPage from "@faire/prototype-playground/workspace/hbul/dormant-products";
import { Route, Switch } from "react-router-dom";

export function HenryBullinghamRoutes() {
  return (
    <Switch>
      <Route
        path="/hbul/allow-delete-product-with-open-invoice"
        component={AllowDeleteProductWithOpenInvoicePage}
      />
      <Route path="/hbul/dormant-products" component={DormantProductsPage} />
    </Switch>
  );
}

export const slug = "hbul";
